var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50065 9.02865C6.25523 9.02865 4.42773 7.20115 4.42773 4.95573C4.42773 2.71031 6.25523 0.882812 8.50065 0.882812C10.7461 0.882812 12.5736 2.71031 12.5736 4.95573C12.5736 7.20115 10.7461 9.02865 8.50065 9.02865ZM8.50065 1.94531C6.84315 1.94531 5.49023 3.29823 5.49023 4.95573C5.49023 6.61323 6.84315 7.96615 8.50065 7.96615C10.1582 7.96615 11.5111 6.61323 11.5111 4.95573C11.5111 3.29823 10.1582 1.94531 8.50065 1.94531Z",
    fill: "#535353"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5851 16.1146C14.2947 16.1146 14.0539 15.8738 14.0539 15.5833C14.0539 13.1396 11.5606 11.1562 8.50063 11.1562C5.44059 11.1562 2.94727 13.1396 2.94727 15.5833C2.94727 15.8738 2.70643 16.1146 2.41602 16.1146C2.1256 16.1146 1.88477 15.8738 1.88477 15.5833C1.88477 12.5588 4.85268 10.0938 8.50063 10.0938C12.1485 10.0938 15.1164 12.5588 15.1164 15.5833C15.1164 15.8738 14.8756 16.1146 14.5851 16.1146Z",
    fill: "#535353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.8039df7eaadedad1ea4276670f80d6eb.svg";
export { ForwardRef as ReactComponent };